module.exports = __webpack_public_path__ + "media/images/icons/espacio-3385472cf242ea01325bd83817460871.svg";